import { css } from 'styled-components'

import { safeParseCoords } from '../formControls/Coords/utils'
import { applySize } from '../formControls/Size/utils'
import type { INodeV2StyledProps } from './NodeV2Styled'

const Coords = (style: INodeV2StyledProps['$style']) => {
  const { top, left, right, bottom } = safeParseCoords(style?.coords)
  return css`
    ${typeof top === 'number' && `top: ${top}px;`}
    ${typeof left === 'number' && `left: ${left}px;`}
    ${typeof right === 'number' && `right: ${right}px;`}
    ${typeof bottom === 'number' && `bottom: ${bottom}px;`}
  `
}

const AbsoluteFlow = (style: INodeV2StyledProps['$style']) => css`
  position: ${style?.flexFlow === 'absolute' ? 'absolute' : 'relative'};
  z-index: ${style?.zIndex};
  ${style?.flexFlow === 'absolute' && Coords(style)};
`

const FlexItemStyled = ({ $style }: INodeV2StyledProps) => css`
  min-width: ${applySize($style?.minWidth)};
  width: ${applySize($style?.width)};
  max-width: ${applySize($style?.maxWidth)};
  min-height: ${applySize($style?.minHeight)};
  height: ${applySize($style?.height)};
  max-height: ${applySize($style?.maxHeight)};

  align-self: ${$style?.alignSelf};
  flex-basis: ${applySize($style?.flexBasis)};
  flex-grow: ${$style?.flexGrow};
  flex-shrink: ${$style?.flexShrink};
  ${AbsoluteFlow($style)};
`

export default FlexItemStyled
